module.exports = __webpack_public_path__ + "static/media/47_B.95d17243.png";